import styled from 'styled-components';
import { MAIN_HEADER_HEIGHT, VIEW_AS_BAR_HEADER } from 'src/utils/constants';

type WrapperProps = {
  hasViewAsBar?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  height: ${({ hasViewAsBar }) =>
    hasViewAsBar
      ? `calc(100vh - ${MAIN_HEADER_HEIGHT} - ${VIEW_AS_BAR_HEADER})`
      : `calc(100vh - ${MAIN_HEADER_HEIGHT})`};
`;

Wrapper.displayName = 'Wrapper';
